import { Area } from './area';

export class Equipo {
  _id:    string;
  nombre: string;
  area:   Area;
}



// WEBPACK FOOTER //
// ./src/dominio/equipo.ts